import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, createSlots as _createSlots, withKeys as _withKeys, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "operation text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_repository_register = _resolveComponent("repository-register")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_confirm_dialog = _resolveComponent("confirm-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, { loading: _ctx.listLoading }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { "no-gutters": "" }, {
              default: _withCtx(() => [
                _cache[9] || (_cache[9] = _createTextVNode(" Repositories ")),
                _createVNode(_component_v_divider, {
                  class: "mx-4",
                  inset: "",
                  vertical: ""
                }),
                _createVNode(_component_v_spacer),
                (!_ctx.isAdmin)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      class: "primary_btn_v2 reg-btn",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.register()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[7] || (_cache[7] = [
                            _createTextVNode("mdi-plus")
                          ])),
                          _: 1
                        }),
                        _cache[8] || (_cache[8] = _createTextVNode(" New Repository "))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, { class: "repo-body" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              class: "mb-5 pt-0",
              cols: "12",
              md: "12",
              xs: "12",
              sm: "6"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_data_table, {
                  items: _ctx.repositoryList,
                  headers: _ctx.getColumnHeaders(),
                  loading: _ctx.listLoading,
                  "custom-sort": _ctx.customSort
                }, _createSlots({
                  "item.CommitmentName": _withCtx(({ item }) => [
                    _createElementVNode("strong", null, _toDisplayString(item.CommitmentName), 1)
                  ]),
                  "item.HttpsLink": _withCtx(({ item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.RepositoryHttpsLink), 1)
                  ]),
                  "item.LastUpdateStatus": _withCtx(({ item }) => [
                    _createElementVNode("span", {
                      innerHTML: _ctx.getLastUpdate(item)
                    }, null, 8, _hoisted_1),
                    _cache[11] || (_cache[11] = _createTextVNode("   ")),
                    (item.LastUpdateStatus === _ctx.lastUpdateStatus.Failed)
                      ? (_openBlock(), _createBlock(_component_v_btn, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, _mergeProps(_ctx.attrs, _toHandlers(_ctx.on), {
                              color: "error",
                              style: {"cursor":"pointer"}
                            }), {
                              default: _withCtx(() => _cache[10] || (_cache[10] = [
                                _createTextVNode(" mdi-information ")
                              ])),
                              _: 1
                            }, 16),
                            (item.LastUpdateStatus === _ctx.lastUpdateStatus.Failed)
                              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                  key: 0,
                                  activator: "parent",
                                  location: "top"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("p", {
                                      class: "failure-tooltip",
                                      innerHTML: item.LastUpdateError
                                    }, null, 8, _hoisted_2)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  "item.ExpiryDate": _withCtx(({ item }) => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(item.ExpiryDate)), 1)
                  ]),
                  "item.Actions": _withCtx(({ item }) => [
                    _createElementVNode("span", _hoisted_3, [
                      _createVNode(_component_v_menu, {
                        bottom: "",
                        left: ""
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_icon, _mergeProps(props, {
                            color: `${_ctx.isAdmin ? 'black' : 'white'}`
                          }), {
                            default: _withCtx(() => _cache[12] || (_cache[12] = [
                              _createTextVNode("mdi-dots-vertical")
                            ])),
                            _: 2
                          }, 1040, ["color"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, null, {
                            default: _withCtx(() => [
                              (!_ctx.isAdmin)
                                ? (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.edit(item)),
                                    "prepend-icon": "mdi-pencil",
                                    title: "Edit"
                                  }, null, 8, ["onClick"]))
                                : _createCommentVNode("", true),
                              (item.LastUpdateStatus === _ctx.lastUpdateStatus.Disabled)
                                ? (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: 1,
                                    onClick: ($event: any) => (_ctx.disableOrEnableTeammemberRepository(item)),
                                    "prepend-icon": "mdi-toggle-switch-off",
                                    title: "Enable"
                                  }, null, 8, ["onClick"]))
                                : (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: 2,
                                    onClick: ($event: any) => (_ctx.disableOrEnableTeammemberRepository(item)),
                                    "prepend-icon": "mdi-toggle-switch",
                                    title: "Disable"
                                  }, null, 8, ["onClick"]))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 2
                }, [
                  (_ctx.isAdmin)
                    ? {
                        name: "item.TeammemberName",
                        fn: _withCtx(({ item }) => [
                          _createElementVNode("strong", null, _toDisplayString(item.TeammemberName), 1)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["items", "headers", "loading", "custom-sort"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["loading"]),
    (_ctx.showRegisterRepo)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          modelValue: _ctx.showRegisterRepo,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showRegisterRepo) = $event)),
          "max-width": "500",
          onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.showRegisterRepo = false), ["esc"])),
          key: _ctx.registerVersion
        }, {
          default: _withCtx(() => [
            _createVNode(_component_repository_register, {
              ref: "editRepo",
              repoModel: _ctx.selectedRepo,
              commitments: _ctx.commitments,
              registerLoading: _ctx.registerLoading,
              onCloseEdit: _ctx.closeEdit,
              onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showRegisterRepo = false)),
              onSaved: _ctx.repoSaved
            }, null, 8, ["repoModel", "commitments", "registerLoading", "onCloseEdit", "onSaved"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      persistent: "",
      modelValue: _ctx.showRemovePopup,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showRemovePopup) = $event)),
      onKeydown: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.showRemovePopup = false), ["esc"])),
      "max-width": "400px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_confirm_dialog, {
          onConfirm: _ctx.removeRepository,
          onCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showRemovePopup = false)),
          loading: _ctx.isDeleting,
          message: _ctx.confirmModel
        }, null, 8, ["onConfirm", "loading", "message"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}